"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _String = _interopRequireDefault(require("./String.js"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _SectionModule = _interopRequireDefault(require("./Section.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A view section
 * 
 * @package HOPS
 * @subpackage Components
 * @copyright Heritage Oeprations Processing Limited
 */class Section extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      children: [!!(this.props.actions || this.props.title) && this.renderHeader(), this.props.header, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
        className: this.props.classNamePaper,
        square: this.props.square,
        style: this.props.paperStyle,
        variant: "outlined",
        children: this.props.children
      }), this.props.footer]
    });
  }

  /**
   * Render the action controls.
   * 
   * @return {ReactNode}
   */
  renderActions() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      alignSelf: "flex-end",
      className: _SectionModule.default.actions,
      columnar: true,
      gap: 0.5,
      justifyContent: "center",
      wrap: true,
      children: this.props.actions
    });
  }

  /**
   * Render the header.
   * 
   * @return {ReactNode}
   */
  renderHeader() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      alignItems: this.props.isMobile && this.props.actions && !this.props.disableMobileCentredTitle ? "center" : undefined,
      columnar: !this.props.isMobile,
      justifyContent: this.props.title ? "space-between" : "flex-end",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        str: this.props.title,
        variant: "h6"
      }), this.props.actions && this.renderActions()]
    });
  }
}
var _default = exports.default = (0, _withMobile.default)(Section);